import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_OFFBOARDINGS, SET_EMPLOYEE_OFFBOARDING, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_OFFBOARDING_ISLOADING,
  DELETE_EMPLOYEE_OFFBOARDING,
  EDIT_EMPLOYEE_OFFBOARDING,
  GET_EMPLOYEE_OFFBOARDINGS,
  GET_EMPLOYEE_OFFBOARDING,
  REGISTER_EMPLOYEE_OFFBOARDING,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeOffboarding from '@/services/employee_offboarding';
import { Module } from 'vuex';
import {
  EditEmployeeOffboarding,
  RegisterEmployeeOffboarding,
  GetEmployeeOffboarding,
} from '@/dtos/employee_offboarding.dto';

const employeeOffboarding: Module<any, {}> = {
  state: {
    employeeOffboarding: {
      data: null,
      isLoading: false,
    },
    employeeOffboardings: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeOffboarding: (state: { employeeOffboarding: any }) => state.employeeOffboarding,
    employeeOffboardings: (state: { employeeOffboardings: any }) => state.employeeOffboardings,
  },
  mutations: {
    [SET_EMPLOYEE_OFFBOARDING]: (
      state: { employeeOffboarding: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeOffboarding.data = payload.data) : null,
        (state.employeeOffboarding.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_OFFBOARDINGS]: (
      state: { employeeOffboardings: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeOffboardings.data = payload.data) : null,
        (state.employeeOffboardings.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_OFFBOARDING]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_OFFBOARDING, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboarding.registerEmployeeOffboarding(
        payload as RegisterEmployeeOffboarding
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_OFFBOARDINGS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_OFFBOARDINGS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboarding.getEmployeeOffboardings(
        payload as GetEmployeeOffboarding
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDINGS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDINGS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDINGS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_OFFBOARDING]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_OFFBOARDING, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboarding.getEmployeeOffboardings(
        payload as GetEmployeeOffboarding
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_OFFBOARDING]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_OFFBOARDING, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboarding.editEmployeeOffboarding(
        payload as EditEmployeeOffboarding
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_OFFBOARDING]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_OFFBOARDING, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboarding.deleteEmployeeOffboarding(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_OFFBOARDING_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_OFFBOARDING, { isLoading: false });
      commit(SET_EMPLOYEE_OFFBOARDINGS, { isLoading: false });
    },
  },
};

export default employeeOffboarding;
